import {
  ID,
  noGroupingId,
  ReorderItem,
  ReorderResult,
  TaskListItemTypes,
} from '@griply/types';

import { filterReorderableChildIds } from './filter-reorderable-child-ids';

export type OnSectionReorderOptions = {
  updatedItems: readonly ReorderItem[];
  hasSections: boolean;
  rootSectionId: ID;
};

export const onSectionReorder = ({
  updatedItems,
  hasSections,
  rootSectionId,
}: OnSectionReorderOptions): ReorderResult => {
  const updatedSections: ReorderResult['updatedSections'] = [];

  updatedItems.forEach((item) => {
    if (item.type === TaskListItemTypes.Section) {
      updatedSections.push({
        id: item.id,
        taskSorting: filterReorderableChildIds(item.children),
      });
      return;
    }

    if (item.type === TaskListItemTypes.Root) {
      updatedSections.push({
        id: hasSections ? rootSectionId : noGroupingId,
        taskSorting: filterReorderableChildIds(item.children),
      });
    }
  });

  return { updatedSections, updatedTasks: [] };
};
